import { motion, AnimatePresence } from "framer-motion";
import { FiUser, FiSettings, FiLogOut, FiChevronRight } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";

const MenuItemsT = ({ isOpen, setProfileDropdown, handleLogout, user }) => {
  const itemVariants = {
    closed: { opacity: 0, x: -10 },
    open: { opacity: 1, x: 0 },
  };

  const menuVariants = {
    closed: {
      opacity: 0,
      scale: 0.95,
      transition: { duration: 0.1, ease: "easeIn" },
    },
    open: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.2,
        ease: "easeOut",
        staggerChildren: 0.05,
        delayChildren: 0.1,
      },
    },
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial="closed"
          animate="open"
          exit="closed"
          variants={menuVariants}
          className="absolute right-0 z-10 w-56 py-2 mt-2 origin-top-right bg-white shadow-xl rounded-xl ring-1 ring-black/5 backdrop-blur-sm"
        >
          <img
            src="https://img.icons8.com/flat-round/50/cancel--v3.png"
            className="absolute w-[1.3rem]  cursor-pointer rounded-xl top-1 right-1"
            alt=""
            onClick={(e) => {
              e.stopPropagation();
              setProfileDropdown(false);
            }}
          />
          <motion.div
            onClick={() => setProfileDropdown(false)}
            variants={itemVariants}
            className="px-1 py-1"
          >
            <div className="px-4 py-3 hover:bg-gray-50">
              <Link
                to={
                  user?.userType === "user" ? "/user/profile" : "/coach"
                }
                onClick={() => localStorage.removeItem("navigation")}
                className="flex items-center text-sm text-gray-700 transition-colors duration-200 rounded-lg"
              >
                <FiUser className="mr-3 text-gray-400" />
                <span>My Profile</span>
                <FiChevronRight className="ml-auto text-gray-300" />
              </Link>
            </div>
          </motion.div>

          {/*   <motion.div
            onClick={() => setProfileDropdown(false)}
            variants={itemVariants}
            className="px-1 py-1"
          >
            <div>
              <a
                href="#"
                className="flex items-center px-4 py-3 text-sm text-gray-700 transition-colors duration-200 rounded-lg hover:bg-gray-50"
              >
                <FiSettings className="mr-3 text-gray-400" />
                <span>Settings</span>
                <FiChevronRight className="ml-auto text-gray-300" />
              </a>
            </div>
          </motion.div>
 */}
          <motion.div
            onClick={() => {
              handleLogout();
              setProfileDropdown(false);
            }}
            variants={itemVariants}
            className="px-1 py-1"
          >
            <div>
              <a
                href="#"
                className="flex items-center px-4 py-3 text-sm transition-colors duration-200 rounded-lg text-rose-600 hover:bg-rose-50"
              >
                <FiLogOut className="mr-3 text-rose-400" />
                <span>Sign out</span>
              </a>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MenuItemsT;
